<div class="ni-moremenu-container">
  <ng-container *ngFor="let option of options; trackBy: trackByValue; let last = last">
    <NiFormOption
      [option]="option"
      [multiple]="multiple"
      [selected]="isOptionSelected(option)"
      [optionLabel]="optionLabel"
      [showBadge]="showBadge"
      (optionClick)="onOptionClick($event)">
    </NiFormOption>
    <!-- Separator line between options (not after last option) -->
    <div *ngIf="!last" class="ni-moremenu-separator"></div>
  </ng-container>
</div> 